<template>
  <div v-for="(error, index) in errors" :key="index" class="flex flex-col gap-y-1">
    <p class="text-red-600 dark:text-red-500 text-sm">{{ error.$message }}</p>
  </div>
</template>

<script setup>
  defineProps({
    errors: {
      type: Array,
      required: true,
    },
  });
</script>
